import React, { useEffect, useState } from "react";
import { get } from "lodash/fp";
import {
  Container,
  Panel,
  Pagination,
  Table,
  Footer,
  Content,
  Button,
  Form,
  Toggle,
  Col,
  SelectPicker,
  Row,
  Grid,
  Divider,
} from "rsuite";
import EditIcon from "@rsuite/icons/Edit";
import TrashIcon from "@rsuite/icons/Trash";
import CustomCell from "../../components/Elements/CustomCell";
import CustomHeaderCell from "../../components/Elements/CustomHeaderCell";
import { updateIn } from "json-immut";
import { useTranslation } from "react-i18next";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { HelperServices } from "../../../core/services/HelperServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import {
  messageTypeArr,
  httpStatusArr,
} from "../../../core/config/AppConstants";
import "./Cities.css";

function Countries() {
  const { Column } = Table;
  const [loading, setLoading] = useState(false);
  const countryList = useSelector((state: any) => state.country.data);
  const [showFilter, setDisplayFilter] = useState(false);
  const [showAdd, setDisplayAdd] = useState(false);
  const [countryData, setCountryData] = useState<any[]>([]);
  const [stateData, setStateData] = useState<any[]>([]);
  const [cityData, setCityData] = useState<any[]>([]);
  const [cityTotal, setCityTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(1);
  const [sort_by, setSortBy] = useState();
  const [sort_order, setSortOrder] = useState();
  const [selectedCityId, setSelectedCityId] = useState(0);
  const [defaultCountry, setDefaultCountry] = useState({ id: "", name: "" });
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [manageCity, setManageCity] = useState<boolean>();
  const cityFormIntialVal = {
    id: "",
    code: "",
    name: "",
    state: [],
    country: [],
    status: 1,
    is_allowed: "0,1",
  };
  const [cityFormData, setCityFormData] = useState<any>(cityFormIntialVal);
  const [errors, setErrors] = useState<any>({});
  const { t } = useTranslation();

  async function getCountries() {
    try {
      setLoading(true);
      if (countryList) {
        let countriesArr = [];
        for (let i of countryList) {
          countriesArr.push({ label: i.country_name, value: i.id });
        }
        setCountryData(countriesArr);
        for (let i of countriesArr) {
          if (i.label == "India") {
            setCityFormData({ ...cityFormIntialVal, ...{ country: i.value } });
            setDefaultCountry({ id: i.value, name: i.label });
            break;
          }
        }
      } else {
        setCountryData([]);
        setStateData([]);
        setCityData([]);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      console.log("error ", error);
    }
  }

  async function getStates(params: any) {
    try {
      const response: any = await HelperServices.getAllValidStates(params);
      if (response && response.status === httpStatusArr.ok) {
        let statesArr = [];
        for (let obj of response.data.data) {
          statesArr.push({ label: obj.state_name, value: obj.id });
        }
        setStateData(statesArr);
      } else {
        UtilityServices.showToaster({
          message: response?.data?.message,
        });
        setStateData([]);
        setCityData([]);
      }
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function getCities(param: any) {
    try {
      setLoading(true);
      const response: any = await HelperServices.getCities(param);
      if (response && response.status === httpStatusArr.ok) {
        setCityData(get("data.data", response));
        setCityTotal(get("data.total", response));
      } else {
        UtilityServices.showToaster({
          message: response?.data?.message,
        });
        setCityData(get("data.data", []));
        setCityTotal(get("data.total", 0));
      }
      setLoading(false);
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  }

  const filterCities = () => {
    let dumpError: any = [];
    let i;
    let data = { ...cityFormData };
    let fieldsConst: any = {
      name: "CITY_NAME",
      code: "CODE",
      country: "COUNTRY",
      state: "STATE",
    };

    for (i in data) {
      if (i == "country" && (data[i] == null || data[i] == "")) {
        dumpError[i] =
          t("PLEASE_SELECT") + " " + t(fieldsConst[i]).toLowerCase();
        setErrors(dumpError);
      } else if (
        (i == "name" || i == "code") &&
        (data[i] == null || data[i] == "")
      ) {
        delete data[i];
      } else {
        delete dumpError[i];
        setErrors(dumpError);
      }
    }

    if (Object.keys(dumpError).length == 0) {
      delete data.id;
      data.page = page;
      data.rows = rows;
      data.is_allowed = "0,1";
      getCities(data);
    }
  };

  const handleCityFormChange = (data: any) => {
    if (data.path == "status") {
      if (data.value) {
        data.value = 1;
      } else {
        data.value = 0;
      }
    } else if (
      data.path == "country" &&
      data.value != null &&
      data.value != ""
    ) {
      getStates({ country: data.value });
    } else if (
      data.path == "state" &&
      (data.value == null || data.value == "")
    ) {
      setPage(1);
      getCities({
        country: cityFormData.country,
        page: 1,
        rows: rows,
        sort_by: sort_by,
        sort_order: sort_order,
        is_allowed: "0,1",
      });
    }

    let form = updateIn(cityFormData, [data.path], data.value);
    setCityFormData(form);
  };

  const addEditCity = async () => {
    try {
      let dumpError: any = [];
      let i;
      let response: any = {};
      let formData = { ...cityFormData };
      let stateOptions = stateData;
      let fieldsConst: any = {
        name: "CITY_NAME",
        code: "CITY_CODE",
        country: "COUNTRY",
        state: "STATE",
      };

      for (i in formData) {
        if (formData[i] == "" && i != "id" && i != "status") {
          if (i == "name" || i == "code") {
            dumpError[i] = t("REQUIRED", {
              field: t(fieldsConst[i]).toLowerCase(),
            });
          } else {
            dumpError[i] =
              t("PLEASE_SELECT") + " " + t(fieldsConst[i]).toLowerCase();
          }
          setErrors(dumpError);
        } else {
          delete dumpError[i];
          setErrors(dumpError);
        }
      }

      if (Object.keys(dumpError).length == 0) {
        setLoading(true);
        let params = {
          id: formData.id,
          city_name: formData.name,
          city_code: formData.code,
          state_id: formData.state,
          status: formData.status,
        };

        if (params.id == "") {
          response = await HelperServices.createCity(params);
        } else {
          response = await HelperServices.updateCity(params);
        }

        if (response && response.status === httpStatusArr.ok) {
          UtilityServices.showToaster({
            message: response?.data?.message,
          });
          await resetCityForm(3);
          setCityFormData({
            ...cityFormIntialVal,
            ...{ country: formData.country, state: formData.state },
          });
          setStateData(stateOptions);
          getCities({
            state: formData.state,
            country: formData.country,
            page: 1,
            rows: rows,
            sort_by: sort_by,
            sort_order: sort_order,
            is_allowed: "0,1",
          });
        } else {
          UtilityServices.showToaster({
            message: response?.data?.message,
          });
        }
      }

      setLoading(false);
    } catch (error: any) {
      console.log("error ", error);
      if (cityFormData.id == "") {
        UtilityServices.showToaster({
          message: error?.message,
          type: messageTypeArr.error,
        });
      } else {
        UtilityServices.showToaster({
          message: error?.message,
          type: messageTypeArr.error,
        });
      }
      setLoading(false);
    }
  };

  const editCity = async (values: any) => {
    setDisplayAdd(true);
    setDisplayFilter(false);
    setCityFormData({
      id: values.id,
      country: values.country_id,
      state: values.state_id,
      code: values.city_code,
      name: values.city_name,
      status: values.status,
    });
  };

  const deleteCity = async (id: number) => {
    try {
      setLoading(true);
      const response: any = await HelperServices.deleteCity(id);
      if (response && response.status === httpStatusArr.ok) {
        UtilityServices.showToaster({
          message: response?.data?.message,
        });
        setPage(1);
        getCities({
          state: cityFormData.state,
          country: cityFormData.country,
          page: 1,
          rows: rows,
          sort_by: sort_by,
          sort_order: sort_order,
          is_allowed: "0,1",
        });
      } else {
        UtilityServices.showToaster({
          message: response?.data?.message,
        });
      }
      setLoading(false);
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  };

  function onPageChange(page: number) {
    setPage(page);
    let formData = { ...cityFormData };
    delete formData.id;
    delete formData.status;
    getCities({
      ...formData,
      ...{
        page: page,
        rows: rows,
        sort_by: sort_by,
        sort_order: sort_order,
        is_allowed: "0,1",
      },
    });
  }

  function onSortChange(dataKey: any, sortType: any) {
    setPage(1);
    setSortBy(dataKey);
    setSortOrder(sortType);
    let formData = { ...cityFormData };
    delete formData.id;
    delete formData.status;
    getCities({
      ...formData,
      ...{
        page: 1,
        rows: rows,
        sort_by: dataKey,
        sort_order: sortType,
        is_allowed: "0,1",
      },
    });
  }

  const handleChangeRows = (rows: any) => {
    setPage(1);
    setRows(rows);
    let formData = { ...cityFormData };
    delete formData.id;
    delete formData.status;
    getCities({
      ...formData,
      ...{
        page: 1,
        rows: rows,
        sort_by: sort_by,
        sort_order: sort_order,
        is_allowed: "0,1",
      },
    });
  };

  async function init() {
    try {
      setManageCity(UtilityServices.hasPermission("manage-city"));
      await getCountries();
    } catch (error: any) {
      console.log("error ", error);
    }
  }

  async function fetchDefaultData() {
    if (defaultCountry.id != "") {
      await getStates({ country: defaultCountry.id });
      await getCities({
        country: defaultCountry.id,
        page: 1,
        rows: 10,
        sort_by: sort_by,
        sort_order: sort_order,
        is_allowed: "0,1",
      });
    }
  }

  const toggleFilterOptions = () => {
    setDisplayFilter((value) => !value);
  };

  const toggleadAddOptions = () => {
    setDisplayAdd((value) => !value);
  };

  const resetCityForm = async (mode: number) => {
    setPage(1);
    setErrors({});
    setStateData([]);
    setCityData([]);
    if (mode == 1) {
      await getStates({ country: defaultCountry.id });
      await getCities({ country: defaultCountry.id });
    } else if (mode == 2) {
      setDisplayFilter(false);
      setDisplayAdd(false);
      await getStates({ country: defaultCountry.id });
      await getCities({ country: defaultCountry.id });
    } else if (mode == 3) {
      await getStates({ country: cityFormData.country });
      await getCities({
        country: cityFormData.country,
        state: cityFormData.state,
      });
    }
    setCityFormData({
      ...cityFormIntialVal,
      ...{
        country: defaultCountry.id,
        code: "",
        name: "",
        state: "",
        status: 1,
      },
    });
  };

  useEffect(() => {
    init();
  }, [countryList]);

  useEffect(() => {
    fetchDefaultData();
  }, [defaultCountry]);

  return (
    <div className="users cntry">
      <Container className="container">
        <Panel>
          <Grid fluid>
            <Row className="show-grid">
              <Col md={12}>
                <h4 className="mb-3">{t("CITIES")}</h4>
              </Col>
              <Col md={12} mdPush={9}>
                <Button
                  appearance="default"
                  size="sm"
                  onClick={toggleFilterOptions}
                  disabled={showAdd}
                >
                  {t("FILTER")}
                </Button>
                &nbsp;
                <Button
                  appearance="primary"
                  size="sm"
                  onClick={toggleadAddOptions}
                  disabled={showFilter}
                >
                  {t("ADD")}
                </Button>
              </Col>
            </Row>
          </Grid>
          {showFilter || showAdd ? (
            <Form formValue={cityFormData}>
              <div className="col-md-12 city-form-div  content pl-0 pb-0 mb-2">
                <div className="row mb-2">
                <div className="col-md-2">
                    <Form.Group>
                      {t("STATUS")}:{" "}
                      <Form.Control
                        name="status"
                        accepter={Toggle}
                        checked={cityFormData.status}
                        onChange={(v: any) =>
                          handleCityFormChange({ path: "status", value: v })
                        }
                      />
                    </Form.Group>
                    </div>
                  <div className="col-md-5 d-flex space-between">
                    <Form.Group controlId="name">
                      <Form.Control
                        name="name"
                        className={
                          errors["name"]
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        placeholder={t("CITY_NAME")}
                        onChange={(v: any) =>
                          handleCityFormChange({ path: "name", value: v })
                        }
                      />
                      <span className="text-danger">{errors["name"]}</span>
                    </Form.Group>
                    <Form.Group controlId="country" className="mb-3">
                      <Form.Control
                        name="country"
                        accepter={SelectPicker}
                        appearance="default"
                        placeholder={t("SELECT_COUNTRY")}
                        data={countryData}
                        className={
                          errors["country"]
                            ? "form-select is-invalid"
                            : "form-select"
                        }
                        onChange={(v: any) =>
                          handleCityFormChange({ path: "country", value: v })
                        }
                      />
                      <span className="text-danger">{errors["country"]}</span>
                    </Form.Group>
                  </div>
                  <div className="col-md-5 d-flex space-between">
                    <Form.Group controlId="code" className="mb-3">
                      <Form.Control
                        name="code"
                        className={
                          errors["code"]
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        placeholder={t("CODE")}
                        onChange={(v: any) =>
                          handleCityFormChange({ path: "code", value: v })
                        }
                      />
                      <span className="text-danger">{errors["code"]}</span>
                    </Form.Group>
                    <Form.Group controlId="state" className="mb-3">
                      <Form.Control
                        name="state"
                        accepter={SelectPicker}
                        appearance="default"
                        placeholder={t("SELECT_STATE")}
                        data={stateData}
                        className={
                          errors["state"]
                            ? "form-select  is-invalid"
                            : "form-select"
                        }
                        onChange={(v: any) => {
                          handleCityFormChange({ path: "state", value: v });
                        }}
                      />
                      <span className="text-danger">{errors["state"]}</span>
                    </Form.Group>
                  </div>
                  </div>
                <div className="form-btn create-action d-flex flex-end mt-2">
                  {showFilter ? (
                    <React.Fragment>
                      <Button
                        className="rs-btn-deflt "
                        appearance="primary"
                        onClick={filterCities}
                      >
                        {t("SEARCH")}
                      </Button>
                      <Button
                        className="rs-btn-blue"
                        appearance="primary"
                        onClick={(e) => resetCityForm(1)}
                      >
                        {t("CLEAR")}
                      </Button>
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                  {showAdd ? (
                    <Button
                      className="rs-btn-green"
                      appearance="primary"
                      onClick={addEditCity}
                    >
                      {t("SAVE")}
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    color="orange"
                    appearance="primary"
                    onClick={(e) => resetCityForm(2)}
                  >
                    {t("CANCEL")}
                  </Button>
                </div>
              </div>
            </Form>
          ) : (
            ""
          )}
          <Content>
            <Table
              loading={loading}
              height={400}
              fillHeight={true}
              data={cityData}
              hover={true}
              onSortColumn={onSortChange}
              sortColumn={sort_by}
              sortType={sort_order}
              bordered
              cellBordered
            >
              <Column fixed flexGrow={1} align="left" sortable>
                <CustomHeaderCell>{t("CITY")}</CustomHeaderCell>
                <CustomCell dataKey="city_name" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("CODE")}</CustomHeaderCell>
                <CustomCell dataKey="city_code" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("STATE")}</CustomHeaderCell>
                <CustomCell dataKey="state_name" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("COUNTRY")}</CustomHeaderCell>
                <CustomCell dataKey="country_name" />
              </Column>

              {manageCity ? (
                <Column flexGrow={1} align="center">
                  <CustomHeaderCell>{t("ACTION")}</CustomHeaderCell>
                  <CustomCell>
                    {(rowData: any) => {
                      return (
                        <React.Fragment>
                          <a
                            href="javascript:void(0)"
                            onClick={() => editCity(rowData)}
                            title={t("EDIT")}
                          >
                            <EditIcon />
                          </a>
                          &nbsp;
                          <a
                            href="javascript:void(0)"
                            onClick={() => {
                              setOpenDeleteModal(true);
                              setSelectedCityId(rowData.id);
                            }}
                            title={t("DELETE")}
                          >
                            <TrashIcon />
                          </a>
                        </React.Fragment>
                      );
                    }}
                  </CustomCell>
                </Column>
              ) : (
                ""
              )}
            </Table>
          </Content>
          <Footer className="footer">
            <Pagination
              total={cityTotal}
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="xs"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              limitOptions={[10, 30, 50, 100]}
              limit={rows}
              activePage={page}
              onChangePage={onPageChange}
              onChangeLimit={handleChangeRows}
            />
          </Footer>
        </Panel>
      </Container>

      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            deleteCity(selectedCityId);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("CITY").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("CITY").toLowerCase(),
        })}
      />
    </div>
  );
}

export default Countries;
